import React, { useState, useEffect, useRef } from 'react'
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'

import { FULFILLED } from '../../constants/constants'
import ExpandCollapseButton from '../ExpandCollapseButton/ExpandCollapseButton'
import Heading from '../Heading/Heading'
import * as Styled from './styles'
import { useAppSelector } from '../../hooks'

interface Props {
  isAddToCartPrompt?: boolean
}

const ArticlesList: React.FC<Props> = ({ isAddToCartPrompt = false }) => {
  const { articles, articlesTotal } = useAppSelector((state) => state.bundle)
  const { applicationMode, content } = useAppSelector((state) => state.init)
  const { isSummaryPreviewExpanded } = useAppSelector((state) => state.ui)
  const { requestStatus_fetchPrices_aggregated } = useAppSelector((state) => state.requests.requestStatus)

  const [isExpanded, setisExpanded] = useState(false)

  const headingRef = useRef<HTMLHeadingElement>(null)

  useEffect(() => {
    if (!headingRef.current) return
    if (!isSummaryPreviewExpanded) return

    if (isExpanded) {
      headingRef.current.scrollIntoView({
        behavior: 'smooth',
        block: window.innerWidth < 1200 ? 'start' : 'end',
      })
    } else {
      headingRef.current.scrollIntoView({
        behavior: 'smooth',
        block: 'end',
      })
    }
  }, [isExpanded])

  return (
    <Styled.ArticlesList
      applicationMode={applicationMode}
      isAddToCartPrompt={isAddToCartPrompt}
      isExpanded={isExpanded}
    >
      {!isAddToCartPrompt && (
        <Heading level={2} ref={headingRef}>
          {requestStatus_fetchPrices_aggregated === FULFILLED ? (
            <ExpandCollapseButton
              isExpanded={isExpanded}
              onClick={() => {
                setisExpanded(!isExpanded)
              }}
              testId={`articles-list-expand-collapse-button-${isExpanded ? 'collapse' : 'expand'}`}
            >
              {content?.other?.articlesListHeading}
              {articlesTotal} {content?.other?.articlesListHeading_2}
            </ExpandCollapseButton>
          ) : (
            <Skeleton width="70%" height="30px" />
          )}
        </Heading>
      )}
      <div
        className="total-and-articles"
        data-testid={`articles-list-content-${isAddToCartPrompt ? 'addToCartPrompt' : 'dialog'}-${applicationMode}-${isExpanded ? 'expanded' : 'collapsed'}`}
      >
        {requestStatus_fetchPrices_aggregated === FULFILLED ? (
          <>
            <span className="total">
              {content?.other?.articlesListDescription} {articlesTotal} {content?.other?.articlesListDescription_2}
            </span>
            <ul>
              {articles &&
                articles.map(({ Quantity, Title, TitleLong }, index) => (
                  // Use index as key since Sku is not guaranteed to be unique due to mallisar
                  <li key={index}>
                    <span className="quantity" data-testid="article-quantity">
                      {Quantity} {content?.other?.pcs}
                    </span>
                    <span className="title-merged" data-testid="article-title">
                      {Title || TitleLong ? (
                        `${Title} ${TitleLong}`
                      ) : (
                        <em>({content?.other?.articleTitleIsMissing})</em>
                      )}
                    </span>
                  </li>
                ))}
            </ul>
          </>
        ) : (
          <Skeleton count={10} height="30px" />
        )}
      </div>
    </Styled.ArticlesList>
  )
}

export default ArticlesList
